import { useState, useEffect } from "react";
import Modal from "../../molecules/Modal";
import Quotation from "../Quotation";
import Header from "../Header";
import { motorAPI } from "../../../api/fetch-api";

const RenewalMotor = (props) => {
  const [isRenewal, setIsRenewal] = useState(true);

  const otherDetails = props.otherDetails || "";

  const [owner, setOwner] = useState(false);
  const [btnValue, setBtnValue] = useState(otherDetails.isOwner);

  const [mortgagee, setMortgagee] = useState(false);
  const [btnMortgagee, setBtnMortgagee] = useState(otherDetails.isMortgage);

  const [color, setColor] = useState(otherDetails.color);
  const [chassisNumber, setChassisNumber] = useState(
    otherDetails.chassisNumber
  );
  const [engineNumber, setEngineNumber] = useState(otherDetails.engineNumber);
  const [ownerName, setOwnerName] = useState(otherDetails.ownerName);
  const [ownerFName, setOwnerFName] = useState(otherDetails.ownerFName);
  const [ownerMName, setOwnerMName] = useState(otherDetails.ownerMName);
  const [ownerLName, setOwnerLName] = useState(otherDetails.ownerLName);
  const [mortgageeid, setMortgageeid] = useState(otherDetails.mortgagee);
  const [mortgageeName, setMortgageeName] = useState(
    otherDetails.mortgageeName
  );

  const [contactNumber, setContactNumber] = useState(
    otherDetails.contactNumber
  );
  const [contactPerson, setContactPerson] = useState(
    otherDetails.contactPerson
  );
  const [emailAddress, setEmailAddress] = useState(otherDetails.emailAddress);
  const [officeAddress, setOfficeAddress] = useState(
    otherDetails.officeAddress
  );

  const [mortgagelist, setMortgagelist] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    motorAPI
      .getMortgagee()
      .then((data) => {
        setLoading(false);
        setMortgagelist(data);
      })
      .catch((err) => console.log("Mortgage Error: ", err));

    if (btnMortgagee === "Y") {
      setMortgagee(true);
      setBtnMortgagee("Y");
    } else {
      setMortgagee(false);
      setBtnMortgagee("N");
    }

    if (btnMortgagee === "Y") {
      setMortgagee(true);
      setBtnMortgagee("Y");
    } else {
      setMortgagee(false);
      setBtnMortgagee("N");
      setContactNumber(null);
      setContactPerson(null);
      setEmailAddress(null);
      setOfficeAddress(null);
      setMortgageeName(null);
      setMortgageeid(null);
    }

    if (btnValue === "N") {
      setOwner(true);
      setBtnValue("N");
    } else {
      setOwner(false);
      setBtnValue("Y");
    }
  }, []);

  const handleUpdates = (e) => {
    let objName = e.target.name;
    if (objName === "color") {
      setColor(e.target.value);
    } else if (objName === "chassisNumber") {
      setChassisNumber(e.target.value);
    } else if (objName === "engineNumber") {
      setEngineNumber(e.target.value);
    } else if (objName === "ownerName") {
      setOwnerName(e.target.value);
    } else if (objName === "ownerFName") {
      setOwnerFName(e.target.value);
    } else if (objName === "ownerMName") {
      setOwnerMName(e.target.value);
    } else if (objName === "ownerLName") {
      setOwnerLName(e.target.value);
    } else if (objName === "mortgageeid") {
      setMortgageeid(e.target.value);
      var index = e.target.selectedIndex;
      setMortgageeName(e.target[index].text);
    } else if (objName === "contactNumber") {
      setContactNumber(e.target.value);
    } else if (objName === "contactPerson") {
      setContactPerson(e.target.value);
    } else if (objName === "emailAddress") {
      setEmailAddress(e.target.value);
    } else if (objName === "officeAddress") {
      setOfficeAddress(e.target.value);
    }
  };

  const handleClickMortgagee = (event) => {
    if (event.target.value === "Y") {
      setMortgagee(true);
      setBtnMortgagee("Y");
    } else {
      setMortgagee(false);
      setBtnMortgagee("N");
    }
  };

  return (
    <Quotation
      handleNextState={(v) => {
        props.handleNextState(v);
      }}
      quoteData={props.quoteData}
      isRenewal={isRenewal}
      btnMortgagee="N"
      mortgaggee={false}
      handleClickMortgagee={handleClickMortgagee}
    />
  );
};

export default RenewalMotor;
